module.exports = "https://coursera_assets.s3.amazonaws.com/images/71180874e10407031ecd7b62e27dec77.png";